import { useMutation } from "@tanstack/react-query";
import { generateCsvCertificate } from "api/services/lesson-service";
import { useAuthContext } from "hooks/useAuthContext";
import { useTranslation } from "react-i18next";
import { buildExportFileName } from "helpers/exportFileName";

interface GenerateCsvCertificateParams {
    userIds: string[];
    lessonId: string;
}

export const useGenerateCsvCertificate = () => {
    const { userState } = useAuthContext();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async ({ userIds, lessonId }: GenerateCsvCertificateParams): Promise<{ blob: Blob; fileName: string }> => {
            const response = await generateCsvCertificate({
                workspaceId: userState.user.selectedWorkspace.workspaceId,
                lessonId,
                userIds,
            });

            if (!response.success || !response.data) {
                throw new Error(response.message ?? 'trainingReport.error');
            }

            return {
                blob: response.data.blob,
                fileName: buildExportFileName(t('trainingReport.fileName')),
            };
        }
    });

    return {
        generateCsvCertificate: mutation.mutateAsync,
        generatingCsvCertificate: mutation.isPending,
    };
};
